<style scoped lang="sass">
.page
  background-color: white !important
  .pools
    padding: var(--base-padding)
    &.ongoing-pools
      background-color: var(--light-gray)
    &.upcoming-pools
      .pool
        background-color: var(--gold)
    &.past-pools
      .pool
        background-color: var(--medium-gray)
    .section-heading
      display: flex
      margin-bottom: 0.5rem
      >:first-child
        flex-grow: 1
    .pool
      display:          block
      border-radius:    0.5rem
      padding:          var(--base-padding)
      border-radius:    var(--base-border-radius)
      background-color: var(--blue)
      margin-bottom:    0.5rem
      color:            white
      .info-line
        display: flex
        align-items: center
        margin-top: 0.5rem
        .avatar
          width: 25px
          height: 25px
          border-radius: 13px
          margin-right: 1rem
        .participation-position
          font-size: 1.6rem
          font-weight: 700
        .participation-position-ordinal
          font-size: 0.8rem
          font-weight: 600
          margin-right: 1rem
        .participation-points
          font-size: 1.6rem
          font-weight: 300
        .participation-points-units
          font-size: 0.8rem
          font-weight: 600
          margin-right: 1rem
</style>
<template>
  <div class="page">
    <pool-participation-offers></pool-participation-offers>
    <div v-if="errorMessages.length">{{errorMessages}}</div>
    <dashboard-blank v-if="dashboardPoolsUpdatedAt && !dashboardPools.length"></dashboard-blank>
    <div v-if="ongoingPools.length" class="pools ongoing-pools">
      <div class="section-heading font-style-2">Ongoing</div>
      <router-link v-for="pool in ongoingPools" class="pool" :to="{name: 'pool', params: {id: pool.id}}" :key="pool.id">
        <div class="pool-name font-style-1">{{pool.name}}</div>
        <div v-if="pool.participation && pool.participation.position" class="info-line">
          <img :src="pool.participation.user.avatar_url" class="avatar">
          <div>
            <span class="participation-position">{{pool.participation.position | pinhighDisplayParticipantPosition({tie: pool.participation.tie, justNumber: true})}}</span><!--
            --><span class="participation-position-ordinal">{{pool.participation.position | pinhighDisplayParticipantPosition({tie: pool.participation.tie, justOrdinal: true})}}</span>
          </div>
          <div>
            <span class="participation-points">{{pool.participation.points}}</span><!--
            --><span class="participation-points-units">PTS</span>
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="upcomingPools.length" class="pools upcoming-pools">
      <div class="section-heading font-style-2">Upcoming</div>
      <router-link v-for="pool in upcomingPools" class="pool" :to="{name: 'pool', params: {id: pool.id}}" :key="pool.id">
        <div class="pool-name font-style-1">{{pool.name}}</div>
      </router-link>
    </div>
    <div v-if="pastPools.length" class="pools past-pools">
      <div class="section-heading font-style-2">
        <span>Past</span>
        <router-link :to="{name: 'poolArchives'}">Pool Archives</router-link>
      </div>
      <router-link v-for="pool in pastPools" class="pool" :to="{name: 'pool', params: {id: pool.id}}" :key="pool.id">
        <div class="pool-name font-style-1">{{pool.name}}</div>
        <div v-if="pool.participation && pool.participation.position" class="info-line">
          <img :src="pool.participation.user.avatar_url" class="avatar">
          <div>
            <span class="participation-position">{{pool.participation.position | pinhighDisplayParticipantPosition({tie: pool.participation.tie, justNumber: true})}}</span><!--
            --><span class="participation-position-ordinal">{{pool.participation.position |  pinhighDisplayParticipantPosition({tie: pool.participation.tie, justOrdinal: true})}}</span>
          </div>
          <div>
            <span class="participation-points">{{pool.participation.points}}</span><!--
            --><span class="participation-points-units">PTS</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import {mapActions}                 from 'vuex';
import moment                       from 'moment';
import _                            from 'lodash';

import PoolParticipationOffers      from './pool-participation-offers.vue';
import DashboardBlank               from './dashboard-blank.vue';
import notificationSetup            from '../notification-setup';

export default {
  name: 'Dashboard',
  components: {
    PoolParticipationOffers,
    DashboardBlank
  },
  data() {
    return {
      errorMessages: [],
      updateInterval: null
    };
  },
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true});
    this.errorMessages = this.$store.getters['messages/getMessage']({key: 'dashboardErrors'}) || [];
    this.$store.dispatch('messages/clearMessage', {key: 'dashboardErrors'});
    if (this.$store.state.participationVerification) {
      this.$router.push({name: 'joinPool', params: {participationVerification: this.$store.state.participationVerification}});
    }
    this.updateDashboardPools();
    this.updateInterval = setInterval(() => this.updateDashboardPools(), 120000);

    // Setup push notifications
    notificationSetup({router: this.$router});
  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
  },
  computed: {
    dashboardPoolsUpdatedAt() {
      return this.$store.state.dashboardPools.updatedAt;
    },
    dashboardPools() {
      return _.values(this.$store.state.dashboardPools.pools);
    },
    pastPools() {
      return this.dashboardPools.filter(pool => pool.tournament.ended);
    },
    ongoingPools() {
      return this.dashboardPools.filter(pool => !pool.tournament.ended && moment(pool.tournament.start_time).isBefore(moment()));
    },
    upcomingPools() {
      return this.dashboardPools.filter(pool => moment(pool.tournament.start_time).isAfter(moment()));
    }
  },
  methods: {
    ...mapActions(['updateDashboardPools']),
  }
};
</script>
